import req from '../utils/request.js'
import local from '@/utils/local.js'

const path = local.getBaseUrl('ims')

/**
 * 电子房价牌登录
 */
export function priceSignLogin(hotelCode) {
  return req.get(`${path}/cbh/hotelInfo/priceSignLogin?hotelCode=${hotelCode}`)
}

/**
 * 获取酒店信息和会员等级信息
 */
export function getBaseInfoApi(hotelCode) {
  return req.get(
    `${path}/cbh/priceSignConf/getHotelInfo?hotelCode=${hotelCode}`
  )
}

/**
 * 获取酒店信息和会员等级信息
 */
export function getBaseInfoNewApi(hotelId, screenType) {
  return req.get(
    `${path}/cbh/priceSignConf/getHotelInfo?hotelId=${hotelId}&screenType=${screenType}`
  )
}

/**
 * 获取酒店房型信息
 */
export function getRoomTypesApi(hotelId, screenType) {
  return req.get(
    `${path}/cbh/priceSignConf/queryRoomTypesInfo?hotelId=${hotelId}&screenType=${screenType}`
  )
}

/**
 * 获取电子房价牌配置
 * screenType integer 0-横版,1-竖版
 */
export function getConfigApi(hotelId, screenType) {
  return req.get(`${path}/cbh/priceSignConf/info/${hotelId}/${screenType}`)
}
